<template>
  <transition name="Anim-Call-Auth-Widget">
    <section class="Wdgt-Auth" v-if="get_isWidgetOpen" @click.self="toClose" @keydown.window="toCloseLast">
      <div class="Wdgt-Auth__wrapper Anim-Call-Auth-Widget__wrapper">
        <div class="Wdgt-Auth__hdr">
          <p class="Wdgt-Auth__ttl">
            <BackButton class="Wdgt-Auth__arrow" v-if="get_isShowArrow" @click="toBack"/> {{ get_title }}
          </p>
          <ButtonClose @click="toClose"/>
        </div>
        <StartLogin v-if="get_isStartLogin" />
        <StartSignup v-else-if="get_isStartSignup" />
        <SignupModule v-else-if="get_isSignupForm"/>
        <LoginForm v-else-if="get_isLoginForm" />
        <ForgotPass v-else-if="get_isForgotPass || get_isForgotPassFromUser" />
        <ForgotPassSuccess v-else-if="get_isForgotPassSuccess"/>
        <LogoutConfirmModule v-else-if="get_isConfirmLogout"/>
      </div>
    </section>
  </transition>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { useRoute } from 'vue-router';
  import { computed, nextTick, onMounted, onUnmounted, onBeforeUnmount } from 'vue';
  import { PATHS_NAME } from '@shared/routers/consts/pathsName.js';
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
  import AUTH_SECTIONS_NAME from '@shared/constants/dropdowns/authSectionsName.js';
  //----------------------------
  import StartLogin from './sections/StartLogin/StartLogin';
  import LoginForm from './sections/LoginForm/LoginForm';
  import StartSignup from './sections/StartSignup/StartSignup';
  import SignupModule from './sections/SignupForm/SignupModule.vue';
  import ForgotPass from './sections/ForgotPass/ForgotPass';
  import ForgotPassSuccess from './sections/ForgotPassSuccess/ForgotPassSuccess.vue';
  import LogoutConfirmModule from './sections/LogoutConfirmModule/LogoutConfirmModule.vue';
  import ButtonClose from '@shared/UI/Buttons/ButtonClose/ButtonClose';
  import BackButton from './components/BackButton/BackButton';
  //----------------------------
  const store = useStore();
  //----------------------------
  const POPUP_NAME = DROPDOWN_NAMES.auth;
  //----------------------------
  onMounted(async () => {
    await nextTick();
    toAddGlobalEventKeydown();
  });
  onUnmounted(() => {
    toRemoveGlobalEventKeydown();
    toResetNavigationArrowDisplay();
  });
  //----------------------------
  const authState = store.state.AuthorizationSystem;
  //----------------------------
  //Открыт/закрыт виджет?
  const get_isWidgetOpen = computed(() => store.getters['Dropdowns/isInList'](POPUP_NAME));
  //Открыта стартовая страница логина
  const get_isStartLogin = computed(() => authState.activeSectionName === AUTH_SECTIONS_NAME.START_LOGIN);
  //Открыта стартовая страница регистрации
  const get_isStartSignup = computed(() => authState.activeSectionName === AUTH_SECTIONS_NAME.START_SIGNUP);
  //Открыта лт форма регистрации
  const get_isSignupForm = computed(() => authState.activeSectionName === AUTH_SECTIONS_NAME.SIGNUP_FORM)
  //Открыта ли форма авторизации
  const get_isLoginForm = computed(() => authState.activeSectionName === AUTH_SECTIONS_NAME.LOGIN_FORM);
  //Открыта ли секция 'Забыли пароль'?
  const get_isForgotPass = computed(() => authState.activeSectionName === AUTH_SECTIONS_NAME.FORGOT_PASS);
  //Открыта ли секция 'Забыли пароль' из под профиля пользователя
  const get_isForgotPassFromUser = computed(() => authState.activeSectionName === AUTH_SECTIONS_NAME.FORGOT_PASS_FROM_USER);
  //Открыта ли секция успешного отправления письма на почту для восстановления пароля
  const get_isForgotPassSuccess = computed(() => authState.activeSectionName === AUTH_SECTIONS_NAME.FORGOT_PASS_SUCCESS)
  //Открыта ли секция 'Подтверждение выхода
  const get_isConfirmLogout = computed(() => authState.activeSectionName === AUTH_SECTIONS_NAME.LOGOUT_CONFIRM);
  //Отображать ли кнопку возврата
  const get_isShowArrow = computed(() => get_isLoginForm.value || get_isForgotPass.value || get_isSignupForm.value);
  //Текст для шапки секции
  const get_title = computed(() => {
    switch(authState.activeSectionName){
      case AUTH_SECTIONS_NAME.START_LOGIN:            return 'Войти';
      case AUTH_SECTIONS_NAME.START_SIGNUP:           return 'Регистрация';
      case AUTH_SECTIONS_NAME.SIGNUP_FORM:            return 'Регистрация';
      case AUTH_SECTIONS_NAME.LOGIN_FORM:             return 'Войти через почту';
      case AUTH_SECTIONS_NAME.FORGOT_PASS:            return 'Сброс пароля';
      case AUTH_SECTIONS_NAME.FORGOT_PASS_FROM_USER:  return 'Сброс пароля';
      case AUTH_SECTIONS_NAME.FORGOT_PASS_SUCCESS:    return 'Сброс пароля';
      case AUTH_SECTIONS_NAME.RESET_PASS_FORM:        return 'Подтверждение пароля';
      case AUTH_SECTIONS_NAME.LOGOUT_CONFIRM:         return 'Выход';
      default:                                        return 'No Text';
    }
  })
  //----------------------------
  //Закрыть виджет
  const toClose = () => store.dispatch('Dropdowns/removeTheDropdown', POPUP_NAME);
  //Закрыть виджет (убрать последний элемент из списка дропдаунов)
  const toCloseLast = (e) => {
    if(e.key !== 'Escape' && e.keyCode !== 27) return;
    store.dispatch('Dropdowns/removeLastDropdown');
  };
  //Выбор секции для перемещения по кнопке стрелки
  const toBack = () => {
    if(get_isLoginForm.value){
      store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.START_LOGIN);
      return;
    }else if(get_isForgotPass.value){
      store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.LOGIN_FORM);
      return;
    }else if(get_isSignupForm.value){
      store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.START_SIGNUP);
      return;
    }
  };
  //Добавить глобальное событие Esc
  const toAddGlobalEventKeydown = () => window.addEventListener('keydown', toCloseLast);
  //Удалить глобальное событие Esc
  const toRemoveGlobalEventKeydown = () => window.removeEventListener('keydown', toCloseLast);
</script>

<style lang="scss">
  @import './styles/_conf.scss';
</style>
